"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = Description;
exports.Label = Label;
exports.ListItem = void 0;
exports.Option = Option;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var React = _interopRequireWildcard(require("react"));
var _reactAria = require("react-aria");
var _Icon = require("../../../../components/media/icon/Icon");
var _globalTokens = require("../../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var ListItem = exports.ListItem = _styledComponents.default.li.withConfig({
  displayName: "Option__ListItem",
  componentId: "sc-u2akko-0"
})(["background:", ";color:", ";", " padding:16px;height:44px;display:flex;align-items:center;justify-content:space-between;cursor:default;outline:none;"], function (props) {
  return props.isFocused ? props.theme.sys.color.background.primary['1'] : '';
}, function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? _globalTokens.globalColor.text.disabled.onLight : _globalTokens.globalColor.text.content.main;
}, _tokens.default.sky.sys.font.subheading[1]);
var StyledDescription = _styledComponents.default.div.withConfig({
  displayName: "Option__StyledDescription",
  componentId: "sc-u2akko-1"
})(["", ""], _tokens.default.sky.sys.font.body[2]);
var ItemContent = _styledComponents.default.div.withConfig({
  displayName: "Option__ItemContent",
  componentId: "sc-u2akko-2"
})(["display:flex;align-items:center;"]);
var OptionContext = /*#__PURE__*/React.createContext({
  labelProps: {},
  descriptionProps: {}
});

// The Label and Description components will be used within an <Item>.
// They receive props from the OptionContext defined above.
// This ensures that the option is ARIA labelled by the label, and
// described by the description, which makes for better announcements
// for screen reader users.

function Label(_ref2) {
  var children = _ref2.children;
  var _React$useContext = React.useContext(OptionContext),
    labelProps = _React$useContext.labelProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({}, labelProps, {
    children: children
  }));
}
function Description(_ref3) {
  var children = _ref3.children;
  var _React$useContext2 = React.useContext(OptionContext),
    descriptionProps = _React$useContext2.descriptionProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDescription, _objectSpread({}, descriptionProps, {
    children: children
  }));
}
function Option(_ref4) {
  var item = _ref4.item,
    state = _ref4.state;
  var ref = React.useRef(null);
  var _ref5 = (0, _reactAria.useOption)({
      key: item.key
    }, state, ref),
    optionProps = _ref5.optionProps,
    labelProps = _ref5.labelProps,
    descriptionProps = _ref5.descriptionProps,
    isSelected = _ref5.isSelected,
    isFocused = _ref5.isFocused,
    isDisabled = _ref5.isDisabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ListItem, _objectSpread({}, optionProps, {
    ref: ref,
    isFocused: isFocused,
    isSelected: isSelected,
    isDisabled: isDisabled,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ItemContent, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(OptionContext.Provider, {
        value: {
          labelProps: labelProps,
          descriptionProps: descriptionProps
        },
        children: item.rendered
      })
    }), isSelected ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'tick'
    }) : null]
  }));
}